<template>
  <div>
  </div>
</template>

<script>
  import Constants from '../constants.json'

  import * as firebase from 'firebase/app'
  // Load the auth feature into the firebase namespace.
  import 'firebase/auth'

  import axios from 'axios'

  export default {
    name: 'PluginConnect',
    data () {
      return {
        authenticated: false,
        method: null,
        embedderId: null,
        context: null

        // appId: null,
        // href: null,
        // taxon: null
      }
    },
    mounted: function () {
      this.initialize()
    },
    methods:  {
      initialize: function () {
        this.authenticated = false
        const currentUser = firebase.auth().currentUser
        if (currentUser) {
          console.log(`Have a user to run plugin ${currentUser.uid}`)
          this.authenticated = true

        } else {
          console.log('DCDLY - Invalid authentication state')
        }

        if (this.authenticated) {

          // Require a method and orgin domain and embedderId so we can run a method and send a response
          this.method = this.$route.query['method'] || null;
          this.embedderId = this.$route.query['embedderId'] || null;
          console.log(`Try to handle method ${this.method} for ${this.embedderId}`)
          if (this.embedderId) {
            this.handleMethod()
          }
        }
      },
      handleMethod: function () {
        this.context = {}
        let handled = false
        switch(this.method) {
          case 'getCompareStatus':
            if(this.buildContext()) {
              console.log(`Should run get compare status with context ${JSON.stringify(this.context)}`)
              // this.postResponse(this.context, {isComparing: false})
              this.getCompareStatus()
            }
            handled = true
            break;
          case 'toggleCompare':
            if(this.buildContext()) {
              console.log(`Should run toggle compare with context ${JSON.stringify(this.context)}`)
              // this.postResponse(this.context, {isComparing: true})
              this.toggleCompare()
            }
            handled = true
            break;
          default:
            handled = false
        }
        if (!handled) {
          const defaultMessage = `DCDLY compare plugin - unexpected method ${this.method}`
          console.log(defaultMessage)
          this.postResponse(this.context, {error: {message: defaultMessage}})
        }
      },
      buildContext: function () {
        let success = false
        this.context = {}
        const queryParams = this.$route.query['params'] || null
        // console.log(`Decode params ${JSON.parse(queryParams)}`)
        if (queryParams) {
          const embedderParams = JSON.parse(decodeURIComponent(queryParams))
          this.context = {...embedderParams}
          if (this.context.taxon && this.context.href && this.context.appId && this.context.targetEl && this.context.origin) {
            success = true
          }
        }
        console.log(`Finished building context with success ${success} context is ${JSON.stringify(this.context)}`)
        return success
      },
      getCompareStatus: async function () {
        if (!this.authenticated) {
          return
        }

        // const tempDecisionKey = `${this.appId}-${this.taxon}` // One decision board per app/taxon pair
        const payload = {url: this.context.href, taxon: this.context.taxon, appId: this.context.appId}
        const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
        const checkComparingURL = `${Constants.API_BASE_PATH}/tempdecisions/checkcomparing`

        const self = this
        axios.post(checkComparingURL, payload, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        }).then(function (response) {
          // handle success

          if (response && response.status === 200 && response.data) {
            const toggleState = response.data.comparing
            self.postResponse(self.context, {isComparing: toggleState})
          } else {
            self.postResponse(self.context, {error: {message: 'Unexpected response from checkcomparing', status: response.status}})
          }

        }).catch((error) => {
          let errorMessage = 'Error calling checkcomparing'
          if (error.response && error.response.data) {
            errorMessage += ` - ${error.response.data.error}`
            console.log(`Error getting compare status for ${self.context.href}. Err: ${error.response.data.error}`)
          } else {
            errorMessage += ` - ${error}`
          }
          self.postResponse(self.context, {error: {message: errorMessage}})
        })

      },
      toggleCompare: async function () {
        if (!this.authenticated) {
          return
        }

        const optionModel = {url: this.context.href, taxon: this.context.taxon, appId: this.context.appId}
        const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
        const toggleOptionURL = `${Constants.API_BASE_PATH}/tempdecisions/togglecompare`

        const self = this
        axios.post(toggleOptionURL, optionModel, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        }).then(function (response) {
          // handle success

          if (response && response.status === 200 && response.data) {
            const toggleState = response.data.comparing
            self.postResponse(self.context, {isComparing: toggleState})
          } else {
            self.postResponse(self.context, {error: {message: 'Unexpected response from checkcomparing', status: response.status}})
          }

        }).catch((error) => {
          let errorMessage = 'Error calling togglecompare'
          if (error.response && error.response.data) {
            errorMessage += ` - ${error.response.data.error}`
            console.log(`Error updating compare status for ${self.context.href}. Err: ${error.response.data.error}`)
          }
          self.postResponse(self.context, {error: {message: errorMessage}})
        })
      },
      postResponse: function (context, payload) {
        const messageData = {action: 'response', embedder: this.embedderId, context: context, ...payload}
        window.parent.postMessage(messageData, context.origin)
      }
    }
  }
</script>
